import { defineStore } from "pinia";

export const useEditorStore = defineStore("editor", {
  state: () => ({
    patches: [],
    links: [],
    areas: [],
    selectedForExport: [],
    showIncomingLinksForPatches: "",
    showOutgoingLinksForPatches: "",
  }),
  getters: {
    getPatches: (state) => state.patches,
    getLinks: (state) => state.links,
    getAreas: (state) => state.areas,
    getSelectedForExport: (state) => state.selectedForExport,
  },
  actions: {
    addPatch(patch) {
      this.patches.push(patch);
    },
    addLink(link) {
      this.links.push(link);
    },
    addArea(area) {
      this.areas.push(area);
    },
    updatePatch(patch) {
      const patchIndex = this.patches.findIndex((p) => p.id === patch?.id);
      if (patchIndex !== -1) {
        this.patches = [...this.patches];
        this.patches[patchIndex] = patch;
      }
    },
    updateArea(area) {
      const areaIndex = this.areas.findIndex((p) => p.id === area?.id);
      if (areaIndex !== -1) {
        this.areas = [...this.areas];
        this.areas[areaIndex] = area;
      }
    },
    updatePatchRegion(patchId, region) {
      const patchIndex = this.patches.findIndex((p) => p.id === patchId);
      if (patchIndex !== -1) {
        this.patches[patchIndex].region = region;
      }
    },
    updatePatchGroup(patchId, group) {
      const patchIndex = this.patches.findIndex((p) => p.id === patchId);
      if (patchIndex !== -1) {
        this.patches[patchIndex].group = group;
      }
    },
    updatePatchVirtual(patchId, isVirtual) {
      const patchIndex = this.patches.findIndex((p) => p.id === patchId);
      if (patchIndex !== -1) {
        this.patches[patchIndex].isVirtual = isVirtual;
      }
    },
    updatePatchJunction(patchId, isJunction) {
      const patchIndex = this.patches.findIndex((p) => p.id === patchId);
      if (patchIndex !== -1) {
        this.patches[patchIndex].isJunction = isJunction;
      }
    },
    updatePatchPort(patchId, isPort) {
      const patches = this.getPatches;
      const patchIndex = patches.findIndex((p) => p.id === patchId);

      if (patchIndex !== -1) {
        const updatedPatch = { ...patches[patchIndex], port: isPort };
        patches[patchIndex] = updatedPatch;
        this.$patch({ patches });
      }
    },
    updateLinkType(linkId, newType) {
      const linkIndex = this.links.findIndex((link) => link.id === linkId);
      if (linkIndex !== -1) {
        this.links[linkIndex].type = newType;
      }
    },
    removePatch(patchId) {
      this.patches = this.patches.filter((patch) => patch.id !== patchId);
    },
    removeLink(linkId) {
      this.links = this.links.filter((link) => link.id !== linkId);
    },
    removeArea(areaId) {
      this.areas = this.areas.filter((area) => area.id !== areaId);
    },
    isAddedToExportSelection(patchId) {
      return this.selectedForExport.includes(patchId);
    },
    addToExportSelection(patchId) {
      if (!this.selectedForExport.includes(patchId)) {
        this.selectedForExport.push(patchId);
      }
    },
    removeFromExportSelection(patchId) {
      this.selectedForExport = this.selectedForExport.filter(
        (id) => id !== patchId
      );
    },
    clearExportSelection() {
      this.selectedForExport = [];
    },
    reset() {
      this.patches = [];
    },
  },
  persist: true,
});
